module.exports = __webpack_public_path__ + "static/media/HDFCLIFE_F1.d4f63b9f.txt";